import { memo, useMemo } from "react";
import { StripeAccountStatus } from "@markit/common.types";
import { Colors } from "../../utils/colors";
import { getAccountState } from "../../redux/slices/accountSlice";
import { useSelector } from "react-redux";
import { testStripe } from "../../utils/stripeAccountUtils";

type StripeConnectLabelProps = {
  showConnectStripeModal: () => void;
};

// Currently only utilized within the ticketing modal
const StripeConnectLabel = memo(function StripeConnectLabelFn(
  props: StripeConnectLabelProps
) {
  const { showConnectStripeModal } = props;
  const { accountData } = useSelector(getAccountState).account;

  const userStripeAccountStatus = useMemo(
    () =>
      testStripe(accountData.uid)
        ? accountData.testStripeAccountStatus || StripeAccountStatus.INCOMPLETE
        : accountData.stripeAccountStatus,
    [
      accountData.uid,
      accountData.stripeAccountStatus,
      accountData.testStripeAccountStatus,
    ]
  );

  const stripeAccountId = useMemo(
    () =>
      testStripe(accountData.uid)
        ? accountData.testStripeAccountId || ""
        : accountData.stripeAccountId,
    [
      accountData.uid,
      accountData.stripeAccountId,
      accountData.testStripeAccountId,
    ]
  );

  return userStripeAccountStatus === StripeAccountStatus.INCOMPLETE ? (
    <span className="smallBodySubtext">
      <span
        onClick={showConnectStripeModal}
        style={{ color: Colors.BLUE5, cursor: "pointer" }}
      >
        {stripeAccountId === ""
          ? "Connect to Stripe"
          : "Finish Connecting Stripe"}
      </span>{" "}
      to enable paid purchasing.
    </span>
  ) : userStripeAccountStatus === StripeAccountStatus.MANUAL_REVIEW ? (
    <span className="smallBodySubtext">
      <span
        onClick={showConnectStripeModal}
        style={{ color: Colors.ORANGE1, cursor: "pointer" }}
      >
        Awaiting Manual Review
      </span>{" "}
      from our team
    </span>
  ) : null;
});

export default StripeConnectLabel;
